import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectTableViewComponent } from './project-table-view/project-table-view.component';
import { ProjectDetailViewComponent } from './project-detail-view/project-detail-view.component';
import { AppRoutingModule } from '../app-routing.module';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { RoomDetailViewComponent } from './room-detail-view/room-detail-view.component';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'project/detail/:projectId/:roomId',
    component: RoomDetailViewComponent,
    // canActivate: [IsAuthenticatedGuard]
  },
];

@NgModule({
  declarations: [
    ProjectTableViewComponent,
    ProjectDetailViewComponent,
    RoomDetailViewComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    MatListModule,
    MatGridListModule,
    MatCheckboxModule,
    RouterModule.forRoot(routes),
    MatSortModule,
  ],
  exports: [RouterModule],
})
export class ProjectModule {}
